import React, { Component } from "react";
import { connect } from "react-redux";
import { signIn } from "../../store/actions/authActions";
import { Redirect } from "react-router-dom";
import { Form, Card } from "react-bootstrap";
import Container from "react-bootstrap/Container";
import "./auth.css";

class SignIn extends Component {
  state = {
    email: "",
    password: "",
  };
  handleChange = (e) => {
    this.setState({
      [e.target.id]: e.target.value,
    });
  };
  handleSubmit = (e) => {
    e.preventDefault();
    this.props.signIn(this.state);
  };
  render() {
    const { authError, auth } = this.props;
    if (auth.uid) return <Redirect to="/" />;
    return (
      <Container className="auth-container" fluid>
        <Card className="signin-card">
          <Form onSubmit={this.handleSubmit} style={{ padding: "1rem" }}>
            <h3>Sign In</h3>
            <Form.Group controlId="formBasicEmail">
              <Form.Label>Email</Form.Label>
              <input
                className="form-control"
                type="email"
                id="email"
                placeholder="Enter email"
                onChange={this.handleChange}
              />
            </Form.Group>
            <div className="form-group">
              <Form.Label>Password</Form.Label>
              <input
                className="form-control"
                type="password"
                id="password"
                placeholder="Enter password"
                onChange={this.handleChange}
              />
            </div>
            <div className="row justify-content-center">
              <button type="submit" className="btn button btn-block ">
                Login
              </button>
            </div>
            <div className="error">{authError ? <p>{authError}</p> : null}</div>
            <div className="error">{authError ? <p>{authError}</p> : null}</div>
            <div className="forgot-password">
              <p>Forgot password?</p>
            </div>
          </Form>
        </Card>
      </Container>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    authError: state.auth.authError,
    auth: state.firebase.auth,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    signIn: (creds) => dispatch(signIn(creds)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SignIn);
